import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import StoreClosedOrderSchedulePopupMobile from "../storeClosedOrderSchedulePopup/storeClosedOrderSchedulePopup";
import ScheduleOrdersMobile from "../scheduleOrderMobile";

interface IOrderScheduleContainerMobileProps {
  onClose: any;
  orderType: string;
  defaultDeliveryTime: any;
  defaultEta: any;
  openingHours: any;
  confirmScheduleDate: any;
  convertTo24Hours: (timeToConvert: any) => string;
  minimumEtaMinutes: any;
  hasLeadTime: boolean;
  cart: any;
  menu: any;
  for: string;
}

function OrderScheduleContainerMobile(
  props: IOrderScheduleContainerMobileProps
) {
  const { allow_order_when_closed = false } = useSelector(
    (state: RootState) => state.company?.configuration || {}
  );
  const { open: storeOpen } = useSelector((state: RootState) => state.storeTimings);

  const { orderType } = props; // Destructure orderType from props

  if (allow_order_when_closed && !storeOpen) {
    return (
      //1 month scheduler popup
      <StoreClosedOrderSchedulePopupMobile
        onClose={props.onClose}
        for={orderType === "pickup" ? "Pickup" : "Delivery"}
        defaultEta={props.defaultEta}
        openingHours={props.openingHours}
        confirmScheduleDate={props.confirmScheduleDate}
        minimumEtaMinutes={props.minimumEtaMinutes}
        hasLeadTime={props.hasLeadTime}
      />
    );
  }

  return (
    <ScheduleOrdersMobile
      onClose={props.onClose}
      for={orderType === "pickup" ? "Pickup" : "Delivery"}
      defaultEta={props.defaultEta}
      openingHours={props.openingHours}
      defaultDeliveryTime={props.defaultDeliveryTime}
      confirmScheduleDate={props.confirmScheduleDate}
      minimumEtaMinutes={props.minimumEtaMinutes}
      hasLeadTime={props.hasLeadTime}
      convertTo24Hours={props.convertTo24Hours}
    />
  );
}

export default OrderScheduleContainerMobile;
